/* HOTFIX thème live 30/07/2026, limite de scroll Lenis figée.
   Le bundle live (pré-hardening) instancie Lenis qui mesure la hauteur de la
   page au premier rendu et ne la rafraîchit jamais ; la page grandit ensuite
   (images/vidéos lazy) et la limite de scroll reste fausse, mesuré sur la
   home : limit 3025 px pour 4250 px réels, soit ~1200 px inaccessibles à la
   molette/trackpad et aux ancres. Recale la mesure à chaque variation de
   hauteur du document. Sans effet si un futur build expose le shim natif
   (pas de .resize). À SUPPRIMER quand le build hardening remplacera ce thème. */
(function () {
  var t;
  function recalc() {
    clearTimeout(t);
    t = setTimeout(function () {
      var l = window.scrollObjectInstance;
      if (l && typeof l.resize === 'function') l.resize();
    }, 150);
  }
  window.addEventListener('load', recalc);
  if ('ResizeObserver' in window) {
    new ResizeObserver(recalc).observe(document.documentElement);
  } else {
    window.addEventListener('resize', recalc);
    setTimeout(recalc, 2000);
    setTimeout(recalc, 5000);
  }
})();

/* AJOUT 31/07/2026, watchdog verrou de scroll mobile.
   Le bundle live pose a l'ouverture des surfaces (panier, menu, recherche...)
   un verrou sur le body : overflow:hidden + classe --prevent-scroll-mobile
   (touch-action:none, applique strictement par Chrome Android, d'ou les
   signalements "la PLP ne scrolle pas sur Chrome mobile" ; iOS tolere).
   La fermeture peut ne jamais arriver (navigation swup drawer ouvert, event
   perdu quand l'onglet est remis au premier plan) et le theme navigue sans
   rechargement : le verrou fantome persiste alors sur toutes les pages.
   Ce watchdog leve le verrou UNIQUEMENT quand aucune surface n'est ouverte. */
(function () {
  var OPEN_CLASSES = [
    'cart-opened', 'has-subnav-open', 'has-search-bar-open',
    'has-mobile-nav-open', 'newsletter-modal-opened', 'bc-filters-opened',
    'bc-confirm-opened', 'stock-alert-opened', 'gift-package-opened',
    'collection-filters-opened'
  ];
  function surfaceOpen() {
    var h = document.documentElement.classList;
    var b = document.body.classList;
    for (var i = 0; i < OPEN_CLASSES.length; i++) {
      if (h.contains(OPEN_CLASSES[i]) || b.contains(OPEN_CLASSES[i])) return true;
    }
    return false;
  }
  function unlockIfStuck() {
    if (surfaceOpen()) return;
    var b = document.body;
    if (b.classList.contains('--prevent-scroll-mobile')) {
      b.classList.remove('--prevent-scroll-mobile');
    }
    if (b.style.overflow === 'hidden') b.style.overflow = '';
    if (b.style.overflowY === 'hidden') b.style.overflowY = '';
    document.documentElement.classList.remove('lenis-stopped');
    var l = window.scrollObjectInstance;
    if (l && l.isStopped && typeof l.start === 'function') l.start();
  }
  setInterval(unlockIfStuck, 1500);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) setTimeout(unlockIfStuck, 400);
  });
})();

/* AJOUT 31/07/2026 bis, overlay de diagnostic scroll (activation : ajouter
   "debug-scroll" a l'URL, ex. coutumes.com/collections/all?debug-scroll).
   Affiche en continu l'etat qui permet de trancher un blocage de scroll
   mobile : detection UA, verrous CSS, hauteurs, compteurs touch et
   preventDefault. Lisible sur une photo d'ecran. */
(function () {
  if (!/debug-scroll/.test(location.href)) return;
  var el = document.createElement('div');
  el.style.cssText = 'position:fixed;left:0;bottom:0;right:0;z-index:2147483647;background:rgba(0,0,0,.85);color:#7CFC00;font:11px/1.5 monospace;padding:8px;pointer-events:none;white-space:pre-wrap';
  document.documentElement.appendChild(el);
  var ts = 0, tm = 0, tmPrev = 0, wheel = 0, scrollEvt = 0;
  window.addEventListener('scroll', function () { scrollEvt++; }, { passive: true });
  function centerEl() {
    try {
      var e = document.elementFromPoint(Math.round(window.innerWidth / 2), Math.round(window.innerHeight / 2));
      if (!e) return 'null';
      var cs = getComputedStyle(e);
      return e.tagName.toLowerCase() + '.' + String(e.className).split(' ').slice(0, 2).join('.').slice(0, 40) +
        ' pe:' + cs.pointerEvents + ' osb:' + cs.overscrollBehavior;
    } catch (err) { return 'err'; }
  }
  window.addEventListener('touchstart', function () { ts++; }, { passive: true });
  window.addEventListener('touchmove', function (e) { tm++; if (e.defaultPrevented) tmPrev++; }, { passive: true });
  window.addEventListener('wheel', function () { wheel++; }, { passive: true });
  setInterval(function () {
    var b = document.body, h = document.documentElement;
    var l = window.scrollObjectInstance || {};
    var cbs = getComputedStyle(b), chs = getComputedStyle(h);
    el.textContent =
      'isMobile:' + window.isMobile + ' android:' + window.isAndroid +
      '\nscrollY:' + Math.round(window.scrollY) + '  docH:' + h.scrollHeight + '  winH:' + window.innerHeight +
      '\nbody touchAction:' + cbs.touchAction + '  ovfl:' + cbs.overflow + ' (inline:' + (b.style.overflow || '-') + '/' + (b.style.overflowY || '-') + ')' +
      '\nhtml ovfl:' + chs.overflow + '  dir:' + (h.getAttribute('data-scroll-direction') || '-') +
      '\nlenis:' + (l.limit !== undefined ? Math.round(l.limit) + (l.isStopped ? ' STOPPED' : '') : 'shim/absent') +
      '\nlenisState isScrolling:' + (l.isScrolling !== undefined ? l.isScrolling : '?') + ' locked:' + (l._isLocked !== undefined ? l._isLocked : '?') + ' target:' + (l.targetScroll !== undefined ? Math.round(l.targetScroll) : '?') + ' anim:' + (l.animatedScroll !== undefined ? Math.round(l.animatedScroll) : '?') +
      '\ntouchstart:' + ts + '  touchmove:' + tm + '  PREVENTED:' + tmPrev + '  scrollEvt:' + scrollEvt +
      '\nsousLeDoigt:' + centerEl() +
      '\nbodyCls:' + (b.className || '-') +
      '\nhtmlCls:' + h.className.split(' ').filter(function (c) { return /open|stopp|mobile|desktop|lenis|scroll|init|ready/.test(c); }).join(' ');
  }, 300);
})();
